'use strict';

/*
DOCUMENT ME
*/

define('modules/module.inventory.generic',[
  'jquery',
  './module.static',
  'lib/util/tda.config'
], function (
  $,
  StaticModule,
  tdaConfig
) {
  var __invUrl = function () {
    if (tdaConfig.tda.code === 'WWW') {
      return '#inventory';
    }
    return '/' + tdaConfig.site.context_url + '/inventory/';
  };

  var InventoryGenericModule = StaticModule.extend({
    events: function () {
      return Object.assign({}, StaticModule.prototype.events, {
        'click .module-cta-0': 'onViewClicked'
      });
    },

    getTemplateContext: function () {
      return $.extend({}, InventoryGenericModule.staticData.all, InventoryGenericModule.staticData[this.getCanvas().getLang()], this.getConfig().data);
    },

    onViewClicked: function (e) {
      if (tdaConfig.tda.code === 'WWW') {
        e && e.preventDefault();
        // handled by zip-tools national links
      }
    }
  }, {
    staticData: {
      all: {
        subtextIcon: '/assets/img/module/inventory/icon-inventory.svg',
        image: {
          '1x1': '/assets/img/module/inventory/inventory-1.jpg',
          '2x1': '/assets/img/module/inventory/inventory-1.jpg',
          '3x1': '/assets/img/module/inventory/inventory-1.jpg'
        }
      },
      en: {
        subtext: 'Toyota Car Inventory',
        headline: 'Browse Toyota Vehicles for Sale',
        copy: {
          '1x1': '<p>Find your favorite Toyota car, truck or hybrid in stock at your local Toyota dealer.</p>'
        },
        actions: [
          {
            title: 'Browse Toyota Stock Now',
            url: __invUrl(),
          }
        ]
      },
      es: {
        subtext: 'Nuevo inventario',
        headline: 'Busca autos Toyota en venta',
        copy: {
          '1x1': '<p>Encuentra tu auto, camioneta o híbrido preferido en tu concesionario Toyota local.</p>'
        },
        actions: [
          {
            title: 'Buscar en el inventario',
            url: __invUrl(),
          }
        ]
      }
    },
  });

  return InventoryGenericModule;
});

